<div class="user-menu">
  <button
    class="no-caret btn btn-icon"
    id="user-menu"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <i class="fal fa-user"></i>
  </button>

  <div class="nav__utility__dropdown" id="user-menu-dropdown">
    <div class="arrow"></div>
    <div class="column col-12 text-align-center">
      <ul class="nav__utility__dropdown__links">
        <li>
          <a
            class="link small fw-normal"
            id="user-menu-account-info-link"
            routerLink="/account"
            >Account Information</a
          >
        </li>
        @if (canSeeAddresses) {
          <li>
            <a
              class="link small fw-normal"
              id="user-menu-addresses-link"
              routerLink="/account/addresses"
              >Addresses</a
            >
          </li>
        }
        @if (canShowPaymentPage) {
          <li>
            <a
              class="link small fw-normal"
              id="user-menu-payment-methods-link"
              routerLink="/account/payment-methods"
              >Payment Methods</a
            >
          </li>
        }
        <li>
          <a
            id="user-menu-orders-toggle"
            class="link small fw-normal"
            (click)="isCollapsed = !isCollapsed"
          >
            Orders
            <i
              class="ms-2 far fa-angle-down"
              [ngClass]="{
                'fa-angle-up': isCollapsed,
                'fa-angle-down': !isCollapsed,
              }"
            ></i>
          </a>

          <ul class="dropdown-menu ps-3" [class.show]="isCollapsed">
            @if (canSeeOrders) {
              <li class="mb-0">
                <a
                  class="link small fw-normal"
                  id="user-menu-order-history-link"
                  routerLink="/account/orders"
                  >Order History</a
                >
              </li>
            }
            @if (canShowTransaction) {
              <li class="mb-0">
                <a
                  class="link small fw-normal"
                  id="user-menu-transactions-link"
                  routerLink="/account/transactions"
                  >Credit Transactions</a
                >
              </li>
            }
            <!-- condition check for invoice -->
            <li class="mb-0">
              <a
                class="link small fw-normal"
                id="user-menu-invoices-link"
                routerLink="/account/invoices"
                >Invoices</a
              >
            </li>
          </ul>
        </li>
        @if (canShowBudgets) {
          <li>
            <a
              class="link small fw-normal"
              id="user-menu-budgets-link"
              routerLink="/account/budgets"
              >Budgets</a
            >
          </li>
        }

        @if (canShowCustomRequestPage) {
          <li>
            <a
              class="link small fw-normal"
              id="user-menu-custom-request-link"
              routerLink="/account/custom-request"
              >Custom Request</a
            >
          </li>
        }
        <li>
          <a
            class="link small fw-normal"
            id="user-menu-news-link"
            routerLink="/account/news"
            >News</a
          >
        </li>
        @if (canSeeRepairRequests) {
          <li>
            <a
              class="link small fw-normal"
              id="user-menu-repair-requests-link"
              routerLink="/account/repair-requests"
              >Repair Request</a
            >
          </li>
        }
      </ul>
      <button
        id="user-menu-signout-btn"
        class="btn btn-primary sign-out mt-2"
        (click)="logoutWarning()"
      >
        Signout
      </button>
    </div>
  </div>
</div>
